import { render, staticRenderFns } from "./featuresButton.vue?vue&type=template&id=be4c52a6&"
import script from "./featuresButton.vue?vue&type=script&lang=js&"
export * from "./featuresButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports